// extracted by mini-css-extract-plugin
export default {"nav":"IntegrationTabs_nav__IexSF","navList":"IntegrationTabs_navList__quo3U","links":"IntegrationTabs_links__KWZND","active":"IntegrationTabs_active__S6zNM"};